<template>
  <!--srcviewscompanylistcompanyvuehtmlStart-->
  <div class="filterMenu">
    <div id="defaultId1" class="uedbd2" style="display: flex">
      <div
        :class="token && this.Saved == '' && !this.Compare ? '' : 'vague'"
        style="height: 100%"
      >
        <div class="left_menu">
          <el-collapse
            v-model="openMenu"
            v-loading="Leftloadig"
            @change="zhankai()"
            ref="collapseItem"
          >
            <!-- 数据分析页面 -->
            <template v-if="isShowAnalysis">
              <el-collapse-item title="Date" name="1">
                <template slot="title">
                  <div class="collapsetitel">Updata Data</div>
                </template>
                <div class="cas_panel cas_loc">
                  <el-select
                    style="width: 100%"
                    clearable
                    v-model="analysisParams.updateDate"
                    filterable
                    :popper-append-to-body="false"
                    popper-class="new-search-select"
                    placeholder="Select Updata Data"
                    @change="analsisCheck()"
                  >
                    <el-option
                      v-for="(item, index) in updateDataList"
                      :key="index"
                      :label="item.groupNameEn"
                      :value="item.groupCode"
                    >
                      <div class="flex-between-center">
                        <el-tooltip
                          effect="light"
                          :visible-arrow="false"
                          :disabled="item?.groupNameEn < 25"
                          :content="item.groupNameEn"
                          placement="right"
                        >
                          <span class="select-name">{{
                            item.groupNameEn
                          }}</span>
                        </el-tooltip>
                      </div>
                    </el-option>
                  </el-select>
                </div>
              </el-collapse-item>

              <el-collapse-item title="Industry" name="2">
                <template slot="title">
                  <div class="collapsetitel">
                    {{ $t("DataManagement.Industry") }}
                  </div>
                </template>
                <div class="cas_panel cas_loc">
                  <el-select
                    style="width: 100%"
                    clearable
                    v-model="analysisParams.industry"
                    filterable
                    :popper-append-to-body="false"
                    popper-class="new-search-select"
                    :placeholder="$t('DataManagement.Selectindustry')"
                    @change="analsisCheck()"
                  >
                    <el-option
                      v-for="(item, index) in industryList"
                      :key="index"
                      :label="item.groupNameEn"
                      :value="item.groupCode"
                    >
                      <div class="flex-between-center">
                        <el-tooltip
                          effect="light"
                          :visible-arrow="false"
                          :disabled="item?.groupNameEn < 25"
                          :content="item.groupNameEn"
                          placement="right"
                        >
                          <span class="select-name">{{
                            item.groupNameEn
                          }}</span>
                        </el-tooltip>
                      </div>
                    </el-option>
                  </el-select>
                </div>
              </el-collapse-item>
            </template>
            <!-- 我的数据页面 -->
            <template v-else>
              <el-collapse-item title="Date" name="1">
                <template slot="title">
                  <div class="collapsetitel">
                    {{ $t("DataManagement.Date") }}
                  </div>
                </template>
                <div class="cas_panel cas_loc">
                  <el-date-picker
                    :append-to-body="true"
                    v-model="datePicker"
                    @change="menuCheck()"
                    type="daterange"
                    range-separator=""
                    :start-placeholder="$t('DataManagement.StartingMonth')"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    :end-placeholder="$t('DataManagement.EndMonth')"
                  ></el-date-picker>
                </div>
              </el-collapse-item>
              <el-collapse-item
                :title="$t('DataManagement.CompanyName')"
                name="2"
              >
                <template slot="title">
                  <div class="collapsetitel">
                    {{ $t("DataManagement.CompanyName") }}
                  </div>
                </template>
                <div class="cas_panel cas_loc">
                  <el-input
                    type="text"
                    v-model="cascInptComapny"
                    clearable
                    :placeholder="$t('DataManagement.Entercompanyname')"
                    @change="menuCheck()"
                  />
                </div>
              </el-collapse-item>

              <el-collapse-item title="Industry" name="3">
                <template slot="title">
                  <div class="collapsetitel">
                    {{ $t("DataManagement.Industry") }}
                  </div>
                </template>
                <div class="cas_panel cas_loc">
                  <el-select
                    style="width: 100%"
                    clearable
                    v-model="cascInptIndustry"
                    filterable
                    :popper-append-to-body="false"
                    popper-class="new-search-select"
                    :placeholder="$t('DataManagement.Selectindustry')"
                    @change="menuCheck()"
                  >
                    <el-option
                      v-for="(item, index) in industryList"
                      :key="index"
                      :label="item.groupNameEn"
                      :value="item.groupNameEn"
                    >
                      <div class="flex-between-center">
                        <el-tooltip
                          effect="light"
                          :visible-arrow="false"
                          :disabled="item?.groupNameEn < 25"
                          :content="item.groupNameEn"
                          placement="right"
                        >
                          <span class="select-name">{{
                            item.groupNameEn
                          }}</span>
                        </el-tooltip>
                      </div>
                    </el-option>
                  </el-select>
                </div>
              </el-collapse-item>
              <el-collapse-item
                :title="$t('DataManagement.CompanyType')"
                name="4"
              >
                <template slot="title">
                  <div class="collapsetitel">
                    {{ $t("DataManagement.CompanyType") }}
                  </div>
                </template>
                <div class="coll_child">
                  <el-checkbox-group
                    v-model="companyTypeCheckList"
                    @change="menuCheck('companyType')"
                  >
                    <el-checkbox
                      v-for="(child, i) in companyTypeList"
                      :key="i"
                      :label="child.groupNameEn"
                    >
                      <el-tooltip
                        :disabled="isShowTooltip"
                        class="line_1"
                        effect="dark"
                        :content="child.groupNameEn"
                        placement="right"
                      >
                        <div
                          @mouseover="onMouseOver(child.groupNameEn, i)"
                          class="line_1"
                        >
                          <span style="font-style: none" ref="str">{{
                            child.groupNameEn
                          }}</span>
                        </div>
                      </el-tooltip>
                      <el-tooltip
                        class="coll_child_num line_1"
                        effect="dark"
                        :content="child.count | FilterNum"
                        placement="right"
                      >
                      </el-tooltip>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
              <el-collapse-item
                :title="$t('DataManagement.CompanyStatus')"
                name="6"
              >
                <template slot="title">
                  <div class="collapsetitel">
                    {{ $t("DataManagement.CompanyStatus") }}
                  </div>
                </template>
                <div class="coll_child">
                  <el-checkbox-group
                    v-model="companyStatusCheckList"
                    @change="menuCheck('companyStatus')"
                  >
                    <el-checkbox
                      v-for="(child, i) in companyStatusList"
                      :key="i"
                      :label="child.groupNameEn"
                    >
                      <div class="line_1">
                        {{ child.groupNameEn }}
                      </div>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
            </template>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";

import { getUserCompanyActionFilter } from "@/api/companyApi";
import { getCompanyAnalysisFilter } from "@/api/userApi";
import { update } from "lodash";

export default {
  mixins: [mixins1],
  components: {},
  name: "",
  props: {},

  updated() {},
  beforeDestroy() {},
  created() {},
  mounted() {
    this.isShowAnalysis = this.$route.path === "/account/enterpriseAnalysis";
    if (this.isShowAnalysis) {
      console.log(11, this.$route.query);
      if (this.$route.query.aaaids) {
        const ids = this.$route.query.aaaids.split("@@") || [];
        this.getCompanyAnalysisFilter(ids);
      }
    } else {
      this.getConditions();
    }
  },
  computed: {},

  data() {
    return {
      datePicker: [],
      isComapanyNameEn: true,
      compareList: [],
      compareListParent: [],
      compareListChildreant: [],
      Remove: false,
      isFadedIn: true,
      loading: true,
      isOpenSlct: false,
      Clearallflase: false,
      showReportIndex: false,
      Compare: false,
      Export: false,
      Download: false,
      Update: false,
      Saved: "",
      Sort: [],
      labelCode: [],
      ReportError: false,
      CompanyName: "",
      powerToReportErrorStatus: false,
      retchildren: false,
      // columns

      token: localStorage.getItem("token"),
      optionsProps: {
        label: "name", //名称展示
        value: "value", //值展示
        expandTrigger: "click", //次级菜单的展开方式
      },
      parentTable: [],
      expands: [],
      cascInptComapny: "",
      showInptCountry: true,
      cascInptIndustry: "",
      showInptIndustry: true,
      childTable: [],

      checkedCompanyList: [],
      companyList: [],
      companyTblList: [],
      branchflag: "",
      openMenu: ["1", "2", "3", "4", "5", "6", "7", "8"],
      countryPreList: [],
      countryList: [],
      countryCheckList: [],
      countryTag: [],
      countryCheck: "",

      industryPreList: [],
      industryList: [],
      industryCheckList: [],
      industryTag: [],
      industryCheck: "",
      //update Data List
      updateDataList: [],

      companyTypeList: [],
      companyTypeList1: [],
      companyTypeCheckList: [],
      companyTypeTag: [],
      companyTypeCheck: "",

      companySizeList: [],
      companySizeCheckList: [],
      companySizeTag: [],
      companySizeCheck: "",

      companyStatusList: [],
      companyStatusCheckList: [],
      companyStatusTag: [],
      companyStatusCheck: "",

      listedCompanyList: [],
      listedCompanyCheckList: [],
      listedCompanyTag: [],
      listedCompanyCheck: "",

      timePeriodList: [],
      timePeriodCheckList: [],
      timeTag: [],
      timePeriodCheck: "",
      province: [],
      city: [],
      keywords: "",
      cascaderKey: 0,
      Leftloadig: false,
      searchName: "",
      isShowTooltip: false,
      checkList: [],
      // 是否显示数据分析页面的筛选菜单
      isShowAnalysis: false,
      analysisParams: {
        updateDate: "",
        industry: "",
      },
    };
  },

  methods: {
    analsisCheck() {
      let Obj = {
        updateDate: this.analysisParams.updateDate,
        industry: this.analysisParams.industry,
      };

      this.$emit("FilterMenuObj", Obj);
    },

    onChangeParams(value, name) {},
    inptCompanySearch() {},

    //
    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
    },

    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#1290C9");
      this.$store.dispatch("app/setSearchType", "company");
    }, //

    zhankai() {
      let hasPower = true;
      if (!hasPower) {
        this.openMenu = [];
      }
    },

    // Company type 超出省略 显示
    onMouseOver(str, i) {
      const tag = this.$refs.str[i];
      const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth;
    },
    //菜单checkbox选择
    menuCheck(val) {
      this.getConditions();
      let Obj = {
        companyName: this.cascInptComapny,
        companyIsicEn: this.cascInptIndustry,
        companyTypeEn: this.companyTypeCheckList[0],
        companyStatusEn: this.companyStatusCheckList[0],
        startTime: this.datePicker == null ? "" : this.datePicker[0],
        endTime: this.datePicker == null ? "" : this.datePicker[1],
      };

      this.$emit("FilterMenuObj", Obj);
    },
    //获取左边菜单
    async getConditions() {
      this.Leftloadig = true;
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;

      const params = {
        userId: userinfo.id,
        portfolioId: "",
        companyName: this.cascInptComapny,
        companyIsicEn: this.cascInptIndustry,
        companyTypeEn: this.companyTypeCheckList[0],
        companyStatusEn: this.companyStatusCheckList[0],
        startTime: this.datePicker == null ? "" : this.datePicker[0],
        endTime: this.datePicker == null ? "" : this.datePicker[1],
      };
      await getUserCompanyActionFilter(params).then((res) => {
        if (res && res.code) {
          this.Leftloadig = false;
          this.industryList = res.data.industryList;
          this.industryPreList = res.data.industryList;

          this.companyTypeList = res.data.companyTypeList;

          this.companySizeList = res.data.companySizeList;
          this.companyStatusList = res.data.companyStatusList;
        } else {
          this.Leftloadig = false;
        }
      });
    },

    //Analysis filter
    getCompanyAnalysisFilter(aaaids) {
      let param = {
        aaaids: aaaids,
      };
      getCompanyAnalysisFilter(param)
        .then((res) => {
          if (res.code == 200) {
            this.industryList = res.data.isicFilterList.map((item) => {
              return {
                groupNameEn: item.industry_name,
                groupCode: item.industry_code,
              };
            });
            //updateDataList
            this.updateDataList = res.data.yearFilterList.map((item) => {
              return {
                groupNameEn: String(item),
                groupCode: String(item),
              };
            });
          }
        })
        .catch((err) => {});
    },
    //国家级联搜索不区分大小写

    // 过滤数据
    createFilter(queryString) {
      return (countryList) => {
        return (
          countryList.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    createFilterInd(queryString) {
      return (industryList) => {
        return (
          industryList.name.toLowerCase().indexOf(queryString.toLowerCase()) >
          -1
        );
      };
    },
    //清除所有标签

    // srcviewscompanylistcompanyvueMethodEnd
  },
};
</script>
<style scoped>
.filterMenu {
  position: fixed;
}
.uedbd2 {
  height: 100%;
}
.left_menu {
  width: 350px;
  padding: 10px 20px 0 20px;
}
.left_menu /deep/ .el-collapse {
  border: none;
}
.left_menu /deep/ .el-collapse-item__arrow {
  position: absolute;
  left: 0 !important;
  right: auto;
}
.left_menu /deep/ .el-collapse-item__header {
  border: none;
}
.left_menu /deep/ .el-collapse-item__wrap {
  border-bottom: 1px solid #eeeeee;
}
.left_menu /deep/ .el-loading-mask {
  background-color: #f5f5f5 !important;
}

.collapsetitel {
  font-family: "Arial Bold";
  position: relative;
  width: 100%;
}
.cas_loc /deep/ .el-date-editor .el-range-input,
.cas_loc /deep/ .el-date-editor .el-range-input::placeholder {
  font-size: 16px !important;
}
.cas_loc /deep/ .el-input__inner {
  width: 100%;
  height: 36px !important;
  line-height: 36px !important;
  font-size: 16px;
  border-radius: 4px;
  background: #ffffff;
}
.cas_loc /deep/ .el-input__inner::placeholder {
  font-size: 16px;
}
/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}
/deep/ .el-collapse-item__wrap {
  overflow: visible !important;
}
/deep/ .new-search-select .el-select-dropdown__item {
  font-size: 16px !important;
}

@media screen and (max-width: 1920px) {
  .left_menu {
    width: 262px;
    padding: 7px 15px 0 15px;
  }
  .collapsetitel {
    font-size: 16px;
  }
  .cas_loc /deep/ .el-date-editor .el-range-input,
  .cas_loc /deep/ .el-date-editor .el-range-input::placeholder {
    font-size: 14px !important;
  }
  .cas_loc /deep/ .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    font-size: 14px;
  }
  .cas_loc /deep/ .el-input__inner::placeholder {
    font-size: 14px;
  }
  /deep/ .new-search-select .el-select-dropdown__list {
    max-width: 225px;
  }
  /deep/ .new-search-select .el-select-dropdown__item {
    font-size: 14px !important;
  }
}
@media screen and (max-width: 1439px) {
  .collapsetitel {
    font-size: 14px;
  }
}
</style>
